var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
import { laggy } from '@juvare/platform-sdk-react/ui/utils';
import { useSearchParams } from 'react-router';
import useSWR from 'swr';
import { checkAndRemoveEmptyArrays } from '../utils';
import { useDocumentLibraryStorage } from './useDocumentLibraryStorage';
export function useFileList(request, mapFileFilter, staticFilterData, currentDirectoryId) {
    const storage = useDocumentLibraryStorage();
    const [searchParams] = useSearchParams();
    const archived = searchParams.get('tab') === 'archived';
    const combinedFilterData = Object.assign(Object.assign({}, staticFilterData), request.filterData);
    const filter = mapFileFilter(combinedFilterData);
    const mappedStorageRequest = Object.assign(Object.assign({}, request.filterData), { filter, orderBy: [
            { column: 'directory', desc: true },
            { column: request.sortColumnKey, desc: request.sortColumnDesc },
        ], offset: request.offset, limit: request.limit, parentId: currentDirectoryId, flatList: !!request.filterData.search, branchFlatList: !!request.filterData.search && !!currentDirectoryId });
    const response = useSWR(['/platform/api/v1/function', mappedStorageRequest, archived], (_a) => __awaiter(this, [_a], void 0, function* ([, request]) {
        return storage.listFiles(Object.assign(Object.assign({}, request), { archived }));
    }), {
        use: [laggy],
        revalidateOnFocus: false,
    });
    return Object.assign(Object.assign({}, response), { data: response.data
            ? {
                rows: response.data.rows,
                filteredRowCount: response.data.total,
            }
            : undefined, reload: response.mutate });
}
export function mapFileFilter(filterData) {
    const { search } = checkAndRemoveEmptyArrays(filterData);
    const filter = [];
    if (search) {
        filter.push({
            op: 'or',
            filter: [
                { column: 'name', op: 'contains', value: search },
                { column: 'ownerDisplayName', op: 'contains', value: search },
            ],
        });
    }
    if (filterData === null || filterData === void 0 ? void 0 : filterData.ownerId) {
        filter.push({ column: 'ownerId', op: '=', value: filterData.ownerId });
    }
    if ((filterData === null || filterData === void 0 ? void 0 : filterData.watching) && (filterData === null || filterData === void 0 ? void 0 : filterData.currentUserId)) {
        filter.push({ column: 'watchersList', op: 'overlap', value: [filterData.currentUserId] });
    }
    return filter;
}
